import { render, staticRenderFns } from "./shortVideo.vue?vue&type=template&id=3457cf2d&scoped=true&"
import script from "./shortVideo.vue?vue&type=script&lang=js&"
export * from "./shortVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3457cf2d",
  null
  
)

export default component.exports